import { render, staticRenderFns } from "./AddNewRequest.vue?vue&type=template&id=3669f906&"
import script from "./AddNewRequest.vue?vue&type=script&lang=js&"
export * from "./AddNewRequest.vue?vue&type=script&lang=js&"
import style0 from "./AddNewRequest.vue?vue&type=style&index=0&id=3669f906&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports